import { Component } from '@theme/component';

const DEV_MOCK = [{"storeGrouping":"North Island","groupingData":[{"title":"ULTRA BEAUTY SYLVIA PARK","subtitle":"Chemist Warehouse Sylvia Park","phone":"09 941 4920","address":"Tenancy N027, Sylvia Park, 286 Mount Wellington Highway, Mount Wellington, Auckland 1060","tags":[{"@odata.type":"#Microsoft.Azure.Connectors.SharePoint.SPListExpandedReference","Id":0,"Value":"Auckland"}],"geo":{"Longitude":174.8398,"Latitude":-36.9135},"openHours":[{"WeekDay":"Sunday","OpenTime":"08:00:00","CloseTime":"22:00:00"},{"WeekDay":"Monday","OpenTime":"08:00:00","CloseTime":"22:00:00"},{"WeekDay":"Tuesday","OpenTime":"08:00:00","CloseTime":"22:00:00"},{"WeekDay":"Wednesday","OpenTime":"08:00:00","CloseTime":"22:00:00"},{"WeekDay":"Thursday","OpenTime":"08:00:00","CloseTime":"22:00:00"},{"WeekDay":"Friday","OpenTime":"08:00:00","CloseTime":"22:00:00"},{"WeekDay":"Saturday","OpenTime":"08:00:00","CloseTime":"22:00:00"}],"grouping":"North Island"},{"title":"ULTRA BEAUTY GLEN INNES","subtitle":"Chemist Warehouse Glen Innes","phone":"09 941 4909","address":"133 Apirana Avenue, Glen Innes, Auckland 1072","tags":[{"@odata.type":"#Microsoft.Azure.Connectors.SharePoint.SPListExpandedReference","Id":0,"Value":"Auckland"}],"geo":{"Longitude":174.85339,"Latitude":-36.8744},"openHours":[{"WeekDay":"Sunday","OpenTime":"08:00:00","CloseTime":"21:00:00"},{"WeekDay":"Monday","OpenTime":"08:00:00","CloseTime":"21:00:00"},{"WeekDay":"Tuesday","OpenTime":"08:00:00","CloseTime":"21:00:00"},{"WeekDay":"Wednesday","OpenTime":"08:00:00","CloseTime":"21:00:00"},{"WeekDay":"Thursday","OpenTime":"08:00:00","CloseTime":"21:00:00"},{"WeekDay":"Friday","OpenTime":"08:00:00","CloseTime":"21:00:00"},{"WeekDay":"Saturday","OpenTime":"08:00:00","CloseTime":"21:00:00"}],"grouping":"North Island"},{"title":"ULTRA BEAUTY CHARTWELL","subtitle":"Chemist Warehouse Chartwell","phone":"07 974 0738","address":"Shop 137, Chartwell Shopping Centre, 201 Hukanui Road, Chartwell, Hamilton 3210","tags":[{"@odata.type":"#Microsoft.Azure.Connectors.SharePoint.SPListExpandedReference","Id":1,"Value":"Hamilton"}],"geo":{"Longitude":175.27246,"Latitude":-37.74753},"openHours":[{"WeekDay":"Sunday","OpenTime":"08:00:00","CloseTime":"19:00:00"},{"WeekDay":"Monday","OpenTime":"08:00:00","CloseTime":"19:00:00"},{"WeekDay":"Tuesday","OpenTime":"08:00:00","CloseTime":"19:00:00"},{"WeekDay":"Wednesday","OpenTime":"08:00:00","CloseTime":"19:00:00"},{"WeekDay":"Thursday","OpenTime":"08:00:00","CloseTime":"21:00:00"},{"WeekDay":"Friday","OpenTime":"08:00:00","CloseTime":"19:00:00"},{"WeekDay":"Saturday","OpenTime":"08:00:00","CloseTime":"19:00:00"}],"grouping":"North Island"},{"title":"ULTRA BEAUTY ALBANY","subtitle":"Chemist Warehouse Albany","phone":"09 941 4906","address":"Tenancy T10a, Albany Mega Centre, 140 Don McKinnon Drive, Albany 0632","tags":[{"@odata.type":"#Microsoft.Azure.Connectors.SharePoint.SPListExpandedReference","Id":0,"Value":"Auckland"}],"geo":null,"openHours":null,"grouping":"North Island"},{"title":"ULTRA BEAUTY RATANUI","subtitle":"Chemist Warehouse Ratanui","phone":"09 872 6730","address":"10-12 Ratanui Street, Henderson, Auckland 0612","tags":[{"@odata.type":"#Microsoft.Azure.Connectors.SharePoint.SPListExpandedReference","Id":0,"Value":"Auckland"}],"geo":null,"openHours":null,"grouping":"North Island"},{"title":"ULTRA BEAUTY EDEN QUARTER","subtitle":"Chemist Warehouse Eden Quarter","phone":"09 871 1124","address":"274 Dominion Road, Mount Eden, Auckland 1024","tags":[{"@odata.type":"#Microsoft.Azure.Connectors.SharePoint.SPListExpandedReference","Id":0,"Value":"Auckland"}],"geo":{"Longitude":174.750917,"Latitude":-36.877089},"openHours":[{"WeekDay":"Sunday","OpenTime":"09:00:00","CloseTime":"19:00:00"},{"WeekDay":"Monday","OpenTime":"08:00:00","CloseTime":"21:00:00"},{"WeekDay":"Tuesday","OpenTime":"08:00:00","CloseTime":"21:00:00"},{"WeekDay":"Wednesday","OpenTime":"08:00:00","CloseTime":"21:00:00"},{"WeekDay":"Thursday","OpenTime":"08:00:00","CloseTime":"21:00:00"},{"WeekDay":"Friday","OpenTime":"08:00:00","CloseTime":"21:00:00"},{"WeekDay":"Saturday","OpenTime":"09:00:00","CloseTime":"19:00:00"}],"grouping":"North Island"},{"title":"ULTRA BEAUTY KILBIRNIE","subtitle":"Chemist Warehouse Kilbirnie","phone":"04 909 0365","address":"31 Bay Road, Wellington, Wellington 6022","tags":[{"@odata.type":"#Microsoft.Azure.Connectors.SharePoint.SPListExpandedReference","Id":6,"Value":"Wellington"}],"geo":{"Longitude":174.79497,"Latitude":-41.3187},"openHours":[{"WeekDay":"Sunday","OpenTime":"08:00:00","CloseTime":"21:00:00"},{"WeekDay":"Monday","OpenTime":"08:00:00","CloseTime":"21:00:00"},{"WeekDay":"Tuesday","OpenTime":"08:00:00","CloseTime":"21:00:00"},{"WeekDay":"Wednesday","OpenTime":"08:00:00","CloseTime":"21:00:00"},{"WeekDay":"Thursday","OpenTime":"08:00:00","CloseTime":"21:00:00"},{"WeekDay":"Friday","OpenTime":"09:00:00","CloseTime":"21:00:00"},{"WeekDay":"Saturday","OpenTime":"08:00:00","CloseTime":"21:00:00"}],"grouping":"North Island"},{"title":"ULTRA BEAUTY CENTRE PLACE","subtitle":"Chemist Warehouse Centre Place","phone":"07 974 0734","address":"Shop 50 & 53 Centre Place, 501 Victoria Street, Hamilton Central, Hamilton 3204","tags":[{"@odata.type":"#Microsoft.Azure.Connectors.SharePoint.SPListExpandedReference","Id":1,"Value":"Hamilton"}],"geo":{"Longitude":175.28062,"Latitude":-37.7865},"openHours":[{"WeekDay":"Sunday","OpenTime":"08:00:00","CloseTime":"21:00:00"},{"WeekDay":"Monday","OpenTime":"08:00:00","CloseTime":"21:00:00"},{"WeekDay":"Tuesday","OpenTime":"08:00:00","CloseTime":"21:00:00"},{"WeekDay":"Wednesday","OpenTime":"08:00:00","CloseTime":"21:00:00"},{"WeekDay":"Thursday","OpenTime":"08:00:00","CloseTime":"21:00:00"},{"WeekDay":"Friday","OpenTime":"08:00:00","CloseTime":"21:00:00"},{"WeekDay":"Saturday","OpenTime":"08:00:00","CloseTime":"21:00:00"}],"grouping":"North Island"},{"title":"ULTRA BEAUTY NEW PLYMOUTH CENTRE CITY","subtitle":"Chemist Warehouse New Plymouth Centre City","phone":"06 882 0064","address":"T9, Centre City Shopping Centre, 11 Gill Street, New Plymouth 4310","tags":[{"@odata.type":"#Microsoft.Azure.Connectors.SharePoint.SPListExpandedReference","Id":5,"Value":"Regional North Island"}],"geo":null,"openHours":null,"grouping":"North Island"},{"title":"ULTRA BEAUTY NEWMARKET BROADWAY","subtitle":"Chemist Warehouse Newmarket Broadway","phone":"09 871 7731","address":"219-225 Broadway, Newmarket, Auckland 1023","tags":[{"@odata.type":"#Microsoft.Azure.Connectors.SharePoint.SPListExpandedReference","Id":0,"Value":"Auckland"}],"geo":{"Longitude":174.777238,"Latitude":-36.869571},"openHours":[{"WeekDay":"Sunday","OpenTime":"09:00:00","CloseTime":"20:00:00"},{"WeekDay":"Monday","OpenTime":"08:00:00","CloseTime":"20:00:00"},{"WeekDay":"Tuesday","OpenTime":"08:00:00","CloseTime":"20:00:00"},{"WeekDay":"Wednesday","OpenTime":"08:00:00","CloseTime":"21:00:00"},{"WeekDay":"Thursday","OpenTime":"08:00:00","CloseTime":"21:00:00"},{"WeekDay":"Friday","OpenTime":"08:00:00","CloseTime":"21:00:00"},{"WeekDay":"Saturday","OpenTime":"09:00:00","CloseTime":"20:00:00"}],"grouping":"North Island"},{"title":"ULTRA BEAUTY PALMERSTON NORTH","subtitle":"Chemist Warehouse Palmerston North","phone":"06 880 8208","address":"233-245 Rangitikei Street, Palmerston North Central, Palmerston North 4410","tags":[{"@odata.type":"#Microsoft.Azure.Connectors.SharePoint.SPListExpandedReference","Id":5,"Value":"Regional North Island"}],"geo":{"Longitude":175.606792,"Latitude":-40.350845},"openHours":[{"WeekDay":"Sunday","OpenTime":"08:00:00","CloseTime":"22:00:00"},{"WeekDay":"Monday","OpenTime":"08:00:00","CloseTime":"22:00:00"},{"WeekDay":"Tuesday","OpenTime":"08:00:00","CloseTime":"22:00:00"},{"WeekDay":"Wednesday","OpenTime":"08:00:00","CloseTime":"22:00:00"},{"WeekDay":"Thursday","OpenTime":"08:00:00","CloseTime":"22:00:00"},{"WeekDay":"Friday","OpenTime":"08:00:00","CloseTime":"22:00:00"},{"WeekDay":"Saturday","OpenTime":"08:00:00","CloseTime":"22:00:00"}],"grouping":"North Island"},{"title":"ULTRA BEAUTY WHANGAPARAOA","subtitle":"Chemist Warehouse Whangaparaoa","phone":"09 886 0722","address":"719A Whangaparaoa Road, Stanmore Bay, Whangaparāoa 0930","tags":[{"@odata.type":"#Microsoft.Azure.Connectors.SharePoint.SPListExpandedReference","Id":0,"Value":"Auckland"}],"geo":{"Longitude":174.747974,"Latitude":-36.636508},"openHours":[{"WeekDay":"Sunday","OpenTime":"09:00:00","CloseTime":"18:00:00"},{"WeekDay":"Monday","OpenTime":"08:30:00","CloseTime":"19:00:00"},{"WeekDay":"Tuesday","OpenTime":"08:30:00","CloseTime":"19:00:00"},{"WeekDay":"Wednesday","OpenTime":"08:30:00","CloseTime":"19:00:00"},{"WeekDay":"Thursday","OpenTime":"08:30:00","CloseTime":"19:00:00"},{"WeekDay":"Friday","OpenTime":"08:30:00","CloseTime":"19:00:00"},{"WeekDay":"Saturday","OpenTime":"09:00:00","CloseTime":"18:00:00"}],"grouping":"North Island"},{"title":"ULTRA BEAUTY NAPIER - PREBENSEN DRIVE","subtitle":"Chemist Warehouse Napier - Prebensen Drive","phone":"06 880 8117","address":"200 Prebensen Drive, Onekawa, Napier 4110","tags":[{"@odata.type":"#Microsoft.Azure.Connectors.SharePoint.SPListExpandedReference","Id":5,"Value":"Regional North Island"}],"geo":{"Longitude":176.882336,"Latitude":-39.496863},"openHours":[{"WeekDay":"Sunday","OpenTime":"09:00:00","CloseTime":"18:00:00"},{"WeekDay":"Monday","OpenTime":"08:30:00","CloseTime":"19:00:00"},{"WeekDay":"Tuesday","OpenTime":"08:30:00","CloseTime":"19:00:00"},{"WeekDay":"Wednesday","OpenTime":"08:30:00","CloseTime":"19:00:00"},{"WeekDay":"Thursday","OpenTime":"08:30:00","CloseTime":"19:00:00"},{"WeekDay":"Friday","OpenTime":"08:30:00","CloseTime":"19:00:00"},{"WeekDay":"Saturday","OpenTime":"09:00:00","CloseTime":"18:00:00"}],"grouping":"North Island"},{"title":"ULTRA BEAUTY ROTORUA","subtitle":"Chemist Warehouse Rotorua","phone":" 07 808 2411","address":"1257 Amohau Street, Rotorua 3010","tags":[{"@odata.type":"#Microsoft.Azure.Connectors.SharePoint.SPListExpandedReference","Id":5,"Value":"Regional North Island"}],"geo":{"Longitude":176.2485531,"Latitude":-38.1396669},"openHours":[{"WeekDay":"Sunday","OpenTime":"08:00:00","CloseTime":"20:00:00"},{"WeekDay":"Monday","OpenTime":"08:00:00","CloseTime":"20:00:00"},{"WeekDay":"Tuesday","OpenTime":"08:00:00","CloseTime":"20:00:00"},{"WeekDay":"Wednesday","OpenTime":"08:00:00","CloseTime":"20:00:00"},{"WeekDay":"Thursday","OpenTime":"08:00:00","CloseTime":"20:00:00"},{"WeekDay":"Friday","OpenTime":"08:00:00","CloseTime":"20:00:00"},{"WeekDay":"Saturday","OpenTime":"08:00:00","CloseTime":"20:00:00"}],"grouping":"North Island"},{"title":"ULTRA BEAUTY CONSTELLATION DRIVE","subtitle":"Chemist Warehouse Constellation Drive","phone":" 09 873 0100","address":" Unit 4, 60 Constellation Drive, Rosedale, Auckland 0632","tags":[{"@odata.type":"#Microsoft.Azure.Connectors.SharePoint.SPListExpandedReference","Id":0,"Value":"Auckland"}],"geo":{"Longitude":174.72775,"Latitude":-36.750022},"openHours":[{"WeekDay":"Sunday","OpenTime":"09:00:00","CloseTime":"19:00:00"},{"WeekDay":"Monday","OpenTime":"08:00:00","CloseTime":"20:00:00"},{"WeekDay":"Tuesday","OpenTime":"08:00:00","CloseTime":"20:00:00"},{"WeekDay":"Wednesday","OpenTime":"08:00:00","CloseTime":"20:00:00"},{"WeekDay":"Thursday","OpenTime":"08:00:00","CloseTime":"20:00:00"},{"WeekDay":"Friday","OpenTime":"08:00:00","CloseTime":"20:00:00"},{"WeekDay":"Saturday","OpenTime":"09:00:00","CloseTime":"19:00:00"}],"grouping":"North Island"}]},{"storeGrouping":"South Island","groupingData":[{"title":"ULTRA BEAUTY MERIDIAN MALL","subtitle":"Chemist Warehouse Meridian Mall","phone":"03 974 6202","address":"Shop G020C, Meridian Mall, 285 George Street, Central Dunedin, Dunedin 9058","tags":[{"@odata.type":"#Microsoft.Azure.Connectors.SharePoint.SPListExpandedReference","Id":3,"Value":"Dunedin"}],"geo":{"Longitude":170.46574,"Latitude":-45.83927},"openHours":[{"WeekDay":"Sunday","OpenTime":"09:00:00","CloseTime":"20:00:00"},{"WeekDay":"Monday","OpenTime":"08:00:00","CloseTime":"20:00:00"},{"WeekDay":"Tuesday","OpenTime":"08:00:00","CloseTime":"20:00:00"},{"WeekDay":"Wednesday","OpenTime":"08:00:00","CloseTime":"20:00:00"},{"WeekDay":"Thursday","OpenTime":"08:00:00","CloseTime":"20:00:00"},{"WeekDay":"Friday","OpenTime":"08:00:00","CloseTime":"20:00:00"},{"WeekDay":"Saturday","OpenTime":"09:00:00","CloseTime":"20:00:00"}],"grouping":"South Island"},{"title":"ULTRA BEAUTY TIMARU","subtitle":"Chemist Warehouse Timaru","phone":" 03 929 2224","address":"233 Evans Street, Smithfield, Timaru 7910","tags":[{"@odata.type":"#Microsoft.Azure.Connectors.SharePoint.SPListExpandedReference","Id":4,"Value":"Regional South Island"}],"geo":null,"openHours":null,"grouping":"South Island"},{"title":"ULTRA BEAUTY HORNBY","subtitle":"Chemist Warehouse Hornby","phone":"03 669 8680","address":"Shop 2, 13-17 Chalmers Street, Hornby, Christchurch 8042","tags":[{"@odata.type":"#Microsoft.Azure.Connectors.SharePoint.SPListExpandedReference","Id":2,"Value":"Christchurch"}],"geo":{"Longitude":172.5220062,"Latitude":-43.5425101},"openHours":[{"WeekDay":"Sunday","OpenTime":"08:00:00","CloseTime":"20:00:00"},{"WeekDay":"Monday","OpenTime":"08:00:00","CloseTime":"20:00:00"},{"WeekDay":"Tuesday","OpenTime":"08:00:00","CloseTime":"20:00:00"},{"WeekDay":"Wednesday","OpenTime":"08:00:00","CloseTime":"20:00:00"},{"WeekDay":"Thursday","OpenTime":"08:00:00","CloseTime":"20:00:00"},{"WeekDay":"Friday","OpenTime":"08:00:00","CloseTime":"20:00:00"},{"WeekDay":"Saturday","OpenTime":"08:00:00","CloseTime":"20:00:00"}],"grouping":"South Island"},{"title":"ULTRA BEAUTY QUEENSTOWN","subtitle":"Chemist Warehouse Queenstown Town Centre","phone":"03 568 0931","address":"Mountaineer Building, 32 Rees St, Queenstown 9300","tags":[{"@odata.type":"#Microsoft.Azure.Connectors.SharePoint.SPListExpandedReference","Id":4,"Value":"Regional South Island"}],"geo":{"Longitude":168.6591727,"Latitude":-45.0320321},"openHours":[{"WeekDay":"Sunday","OpenTime":"08:00:00","CloseTime":"22:00:00"},{"WeekDay":"Monday","OpenTime":"08:00:00","CloseTime":"22:00:00"},{"WeekDay":"Tuesday","OpenTime":"08:00:00","CloseTime":"22:00:00"},{"WeekDay":"Wednesday","OpenTime":"08:00:00","CloseTime":"22:00:00"},{"WeekDay":"Thursday","OpenTime":"08:00:00","CloseTime":"22:00:00"},{"WeekDay":"Friday","OpenTime":"08:00:00","CloseTime":"22:00:00"},{"WeekDay":"Saturday","OpenTime":"08:00:00","CloseTime":"22:00:00"}],"grouping":"South Island"},{"title":"ULTRA BEAUTY RICCARTON MALL","subtitle":"Chemist Warehouse Westfield Riccarton","phone":"03 667 0901","address":"Shop 412A, Westfield Riccarton, 129 Riccarton Road, Christchurch 8041","tags":[{"@odata.type":"#Microsoft.Azure.Connectors.SharePoint.SPListExpandedReference","Id":2,"Value":"Christchurch"}],"geo":{"Longitude":172.598832,"Latitude":-43.530833},"openHours":[{"WeekDay":"Sunday","OpenTime":"09:00:00","CloseTime":"19:00:00"},{"WeekDay":"Monday","OpenTime":"08:00:00","CloseTime":"20:00:00"},{"WeekDay":"Tuesday","OpenTime":"08:00:00","CloseTime":"20:00:00"},{"WeekDay":"Wednesday","OpenTime":"08:00:00","CloseTime":"20:00:00"},{"WeekDay":"Thursday","OpenTime":"08:00:00","CloseTime":"21:00:00"},{"WeekDay":"Friday","OpenTime":"08:00:00","CloseTime":"21:00:00"},{"WeekDay":"Saturday","OpenTime":"08:00:00","CloseTime":"19:00:00"}],"grouping":"South Island"},{"title":"ULTRA BEAUTY NORTHWOOD","subtitle":"Chemist Warehouse Northwood","phone":"03 667 2592","address":"Part Unit A, 1 Radcliffe Rd, Northwood Supa Centa, Belfast, Christchurch 8051","tags":[{"@odata.type":"#Microsoft.Azure.Connectors.SharePoint.SPListExpandedReference","Id":2,"Value":"Christchurch"}],"geo":{"Longitude":172.6231844,"Latitude":-43.4607185},"openHours":[{"WeekDay":"Sunday","OpenTime":"08:00:00","CloseTime":"18:00:00"},{"WeekDay":"Monday","OpenTime":"08:00:00","CloseTime":"18:00:00"},{"WeekDay":"Tuesday","OpenTime":"08:00:00","CloseTime":"18:00:00"},{"WeekDay":"Wednesday","OpenTime":"08:00:00","CloseTime":"18:00:00"},{"WeekDay":"Thursday","OpenTime":"08:00:00","CloseTime":"18:00:00"},{"WeekDay":"Friday","OpenTime":"08:00:00","CloseTime":"18:00:00"},{"WeekDay":"Saturday","OpenTime":"08:00:00","CloseTime":"18:00:00"}],"grouping":"South Island"},{"title":"ULTRA BEAUTY WAIMAKARIRI JUNCTION","subtitle":"Chemist Warehouse Waimakariri Junction","phone":"03 5631620","address":"Unit E, Waimakariri Junction, 13 Hakarau Road, Kaiapoi 7630","tags":[{"@odata.type":"#Microsoft.Azure.Connectors.SharePoint.SPListExpandedReference","Id":2,"Value":"Christchurch"}],"geo":{"Longitude":172.649237,"Latitude":-43.376282},"openHours":[{"WeekDay":"Sunday","OpenTime":"09:00:00","CloseTime":"18:00:00"},{"WeekDay":"Monday","OpenTime":"09:00:00","CloseTime":"18:00:00"},{"WeekDay":"Tuesday","OpenTime":"09:00:00","CloseTime":"18:00:00"},{"WeekDay":"Wednesday","OpenTime":"09:00:00","CloseTime":"18:00:00"},{"WeekDay":"Thursday","OpenTime":"09:00:00","CloseTime":"18:00:00"},{"WeekDay":"Friday","OpenTime":"09:00:00","CloseTime":"18:00:00"},{"WeekDay":"Saturday","OpenTime":"09:00:00","CloseTime":"18:00:00"}],"grouping":"South Island"},{"title":"ULTRA BEAUTY CHRISTCHURCH CITY CENTRE","subtitle":"Chemist Warehouse Christchurch City Centre","phone":"03 669 5418","address":"254 High Street, Christchurch Central City, Christchurch 8011","tags":[{"@odata.type":"#Microsoft.Azure.Connectors.SharePoint.SPListExpandedReference","Id":2,"Value":"Christchurch"}],"geo":{"Longitude":172.637662,"Latitude":-43.532489},"openHours":[{"WeekDay":"Sunday","OpenTime":"09:00:00","CloseTime":"18:00:00"},{"WeekDay":"Monday","OpenTime":"08:00:00","CloseTime":"18:00:00"},{"WeekDay":"Tuesday","OpenTime":"08:00:00","CloseTime":"18:00:00"},{"WeekDay":"Wednesday","OpenTime":"08:00:00","CloseTime":"18:00:00"},{"WeekDay":"Thursday","OpenTime":"08:00:00","CloseTime":"18:00:00"},{"WeekDay":"Friday","OpenTime":"08:00:00","CloseTime":"18:00:00"},{"WeekDay":"Saturday","OpenTime":"09:00:00","CloseTime":"18:00:00"}],"grouping":"South Island"}]}];

const DAY_NAMES = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
const TODAY_NAMES = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
const MAX_RESULTS = 10;
const MAX_DISTANCE_KM = 20;

let mapsApiPromise;

function loadGoogleMapsApi(key) {
  if (window.google?.maps?.places) return Promise.resolve(window.google.maps);
  if (mapsApiPromise) return mapsApiPromise;

  mapsApiPromise = new Promise((resolve, reject) => {
    const callbackName = `__storeLocatorMapsReady_${Date.now()}`;
    const script = document.createElement('script');
    const url = new URL('https://maps.googleapis.com/maps/api/js');

    const cleanup = () => {
      delete window[callbackName];
    };

    window[callbackName] = () => {
      cleanup();
      resolve(window.google?.maps);
    };

    script.addEventListener(
      'error',
      () => {
        cleanup();
        mapsApiPromise = undefined;
        reject(new Error('Failed to load the Google Maps API.'));
      },
      { once: true }
    );

    url.searchParams.set('key', key);
    url.searchParams.set('libraries', 'places');
    url.searchParams.set('callback', callbackName);

    script.src = url.toString();
    script.async = true;
    script.defer = true;
    script.dataset.storeLocatorMaps = 'true';
    document.head.append(script);
  });

  return mapsApiPromise;
}

class StoreLocator extends Component {
  #stores = [];
  #storesPromise = Promise.resolve();
  #mapsPromise;
  #autocomplete;
  #geocoder;
  #initialized = false;

  #handleUseCurrentLocation = (event) => {
    event.preventDefault();
    void this.#useCurrentLocation();
  };

  #handleSearchSubmit = (event) => {
    event.preventDefault();
    void this.#searchByInput();
  };

  /** @param {Event} event */
  #handleDetailsToggle = (event) => {
    if (!(event.target instanceof Element)) return;
    const btn = event.target.closest('.store-card__details-toggle');
    if (!btn) return;
    const expanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!expanded));
    const content = document.getElementById(btn.getAttribute('aria-controls') ?? '');
    if (content) content.hidden = expanded;
  };

  connectedCallback() {
    super.connectedCallback();

    this.refs.searchForm?.removeEventListener('submit', this.#handleSearchSubmit);
    this.refs.useLocation?.removeEventListener('click', this.#handleUseCurrentLocation);
    this.removeEventListener('click', this.#handleDetailsToggle);

    this.refs.searchForm?.addEventListener('submit', this.#handleSearchSubmit);
    this.refs.useLocation?.addEventListener('click', this.#handleUseCurrentLocation);
    this.addEventListener('click', this.#handleDetailsToggle);

    if (this.#initialized) return;
    this.#initialized = true;

    const apiUrl = this.dataset.apiUrl?.trim();
    const mapsKey = this.dataset.mapsKey?.trim();
    const devMode = this.hasAttribute('data-dev-mode');

    this.#storesPromise = devMode ? this.#loadMockData() : apiUrl ? this.#fetchStores(apiUrl) : Promise.resolve([]);

    if (mapsKey) {
      this.#mapsPromise = loadGoogleMapsApi(mapsKey)
        .then(() => {
          if (!this.isConnected) return;
          this.#initMaps();
        })
        .catch((error) => {
          console.error('[StoreLocator] Failed to initialize Google Maps:', error);
        });
    }
  }

  disconnectedCallback() {
    this.refs.searchForm?.removeEventListener('submit', this.#handleSearchSubmit);
    this.refs.useLocation?.removeEventListener('click', this.#handleUseCurrentLocation);
    this.removeEventListener('click', this.#handleDetailsToggle);
    super.disconnectedCallback();
  }

  async #loadMockData() {
    console.info('[StoreLocator] Using mock data');
    this.#stores = this.#filterStores(this.#parseStoreData(DEV_MOCK));
    return this.#stores;
  }

  async #fetchStores(url) {
    try {
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const data = await response.json();
      this.#stores = this.#filterStores(this.#parseStoreData(data));
      return this.#stores;
    } catch (error) {
      console.error('[StoreLocator] Failed to load stores:', error);
      this.#stores = [];
      this.#setStatus('We could not load store locations right now. Please try again later.', 'error');
      return [];
    }
  }

  #parseStoreData(data) {
    return (Array.isArray(data) ? data : []).flatMap(({ groupingData }) =>
      (groupingData ?? []).map((store) => ({
        channel: {
          key: store.title,
          name: store.title,
          capabilities: ['ub-nz'],
          address: {
            country: 'NZ',
            streetNumber: store.address,
            city: store.tags?.[0]?.Value ?? '',
            state: '',
            postalCode: '',
            phone: store.phone?.trim() ?? '',
          },
          coordinates: store.geo
            ? { latitude: store.geo.Latitude, longitude: store.geo.Longitude }
            : null,
          openingHours: Object.fromEntries(
            (store.openHours ?? []).map(({ WeekDay, OpenTime, CloseTime }) => [
              WeekDay.toLowerCase(),
              { from: OpenTime, to: CloseTime },
            ])
          ),
        },
      }))
    );
  }

  #filterStores(channels) {
    return channels.filter(({ channel }) => {
      const lat = Number(channel?.coordinates?.latitude);
      const lng = Number(channel?.coordinates?.longitude);

      return (
        Array.isArray(channel?.capabilities) &&
        channel.capabilities.includes('ub-nz') &&
        channel.address?.country === 'NZ' &&
        Number.isFinite(lat) &&
        Number.isFinite(lng)
      );
    });
  }

  #initMaps() {
    if (!window.google?.maps) return;

    this.#geocoder ??= new google.maps.Geocoder();

    const input = this.refs.input;
    if (!(input instanceof HTMLInputElement) || this.#autocomplete || !window.google.maps.places?.Autocomplete) {
      return;
    }

    this.#autocomplete = new google.maps.places.Autocomplete(input, {
      componentRestrictions: { country: 'nz' },
      fields: ['formatted_address', 'geometry'],
      types: ['geocode'],
    });

    this.#autocomplete.addListener('place_changed', () => {
      const place = this.#autocomplete?.getPlace();

      if (!place?.geometry?.location) {
        this.#setStatus('Select a suggested suburb or postcode, or submit your search.', 'error');
        return;
      }

      const label = place.formatted_address ?? input.value.trim();
      void this.#showStoresNearFromCoordinates(place.geometry.location.lat(), place.geometry.location.lng(), label);
    });
  }

  async #searchByInput() {
    const input = this.refs.input;
    if (!(input instanceof HTMLInputElement)) return;

    const query = input.value.trim();
    if (!query) {
      this.#setStatus('Enter a suburb or postcode to find nearby stores.', 'error');
      input.focus();
      return;
    }

    await this.#waitForMaps();
    const storesLoaded = await this.#ensureStoresLoaded();

    if (!storesLoaded) {
      this.#setStatus('Store locations are unavailable right now. Please try again later.', 'error');
      return;
    }

    if (!this.#geocoder) {
      this.#setStatus('Search is unavailable right now. Try using your current location instead.', 'error');
      return;
    }

    this.#setLoading(true);

    this.#geocoder.geocode(
      {
        address: query,
        componentRestrictions: { country: 'NZ' },
      },
      (results, status) => {
        this.#setLoading(false);

        const match = Array.isArray(results) ? results[0] : undefined;
        if (status !== 'OK' || !match?.geometry?.location) {
          this.#setStatus(`We couldn't find "${query}". Try a suburb or postcode in New Zealand.`, 'error');
          return;
        }

        const label = match.formatted_address ?? query;
        this.#showStoresNear(match.geometry.location.lat(), match.geometry.location.lng(), label);
      }
    );
  }

  async #useCurrentLocation() {
    if (!navigator.geolocation) {
      this.#setStatus('Your browser does not support current location lookup.', 'error');
      return;
    }

    this.#setLoading(true);

    navigator.geolocation.getCurrentPosition(
      async ({ coords: { latitude, longitude } }) => {
        const storesLoaded = await this.#ensureStoresLoaded();

        if (!storesLoaded) {
          this.#setLoading(false);
          this.#setStatus('Store locations are unavailable right now. Please try again later.', 'error');
          return;
        }

        const label = await this.#reverseGeocode(latitude, longitude);
        const input = this.refs.input;
        if (input instanceof HTMLInputElement) {
          input.value = label;
        }

        this.#showStoresNear(latitude, longitude, label);
      },
      (error) => {
        this.#setLoading(false);
        this.#setStatus(this.#getGeolocationErrorMessage(error), 'error');
      },
      {
        enableHighAccuracy: false,
        timeout: 10000,
      }
    );
  }

  async #waitForMaps() {
    if (!this.#mapsPromise) return;

    try {
      await this.#mapsPromise;
    } catch {
      // Leave user-facing messaging to the action that needed maps support.
    }
  }

  async #ensureStoresLoaded() {
    this.#setLoading(true);
    await this.#storesPromise;
    this.#setLoading(false);
    return this.#stores.length > 0;
  }

  async #reverseGeocode(lat, lng) {
    await this.#waitForMaps();

    if (!this.#geocoder) {
      return 'your current location';
    }

    return new Promise((resolve) => {
      this.#geocoder.geocode({ location: { lat, lng } }, (results, status) => {
        const match = Array.isArray(results) ? results[0] : undefined;

        if (status === 'OK' && match?.formatted_address) {
          resolve(match.formatted_address);
          return;
        }

        resolve('your current location');
      });
    });
  }

  async #showStoresNearFromCoordinates(lat, lng, label) {
    const storesLoaded = await this.#ensureStoresLoaded();
    if (!storesLoaded) {
      this.#setStatus('Store locations are unavailable right now. Please try again later.', 'error');
      return;
    }

    this.#showStoresNear(lat, lng, label);
  }

  #showStoresNear(lat, lng, label) {
    const sorted = this.#stores
      .map(({ channel }) => ({
        channel,
        distance: this.#haversine(
          lat,
          lng,
          Number(channel.coordinates.latitude),
          Number(channel.coordinates.longitude)
        ),
      }))
      .filter(({ distance }) => Number.isFinite(distance) && distance <= MAX_DISTANCE_KM)
      .sort((a, b) => a.distance - b.distance)
      .slice(0, MAX_RESULTS);

    const resultCount = sorted.length;

    if (resultCount === 0) {
      this.#setStatus(`There are no stores near ${label}. Try another suburb or postcode.`, 'error');
    } else {
      this.#setStatus(
        `Showing ${resultCount} nearest ${resultCount === 1 ? 'store' : 'stores'} to ${label}.`,
        'success'
      );
    }

    this.#renderResults(sorted, label);
  }

  #renderResults(stores, label) {
    const results = this.refs.results;
    const resultsSummary = this.refs.resultsSummary;

    if (!(results instanceof HTMLElement)) return;

    if (resultsSummary instanceof HTMLElement) {
      if (stores.length === 0) {
        resultsSummary.hidden = true;
        resultsSummary.textContent = '';
      } else {
        resultsSummary.hidden = false;
        resultsSummary.textContent = `${stores.length} nearest ${stores.length === 1 ? 'store' : 'stores'} to ${label}`;
      }
    }

    if (stores.length === 0) {
      results.innerHTML = `<div class="store-locator__no-results">
  <svg class="store-locator__no-results-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <circle cx="12" cy="12" r="10" fill="currentColor"/>
    <path d="M12 7v5" stroke="var(--color-background)" stroke-width="2" stroke-linecap="round"/>
    <circle cx="12" cy="16.5" r="1" fill="var(--color-background)"/>
  </svg>
  <div>
    <p class="store-locator__no-results-heading">There are no stores nearby.</p>
    <p class="store-locator__no-results-sub">Try another suburb or postcode, or use your current location.</p>
  </div>
</div>`;
      return;
    }

    results.innerHTML = `<ol class="store-locator__results-list">
  ${stores
    .map(
      ({ channel }) => `<li class="store-locator__result">
    ${this.#renderCard(channel)}
  </li>`
    )
    .join('')}
</ol>`;
  }

  #renderCard(channel) {
    const { address = {}, key, name = '', openingHours = {} } = channel;
    const fullAddress = [address.streetNumber, address.city, address.state, address.postalCode]
      .filter(Boolean)
      .join(', ');
    const mapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(fullAddress)}`;
    const phone = address.phone ?? '';
    const cityLine = [address.city, address.state].filter(Boolean).join(', ');
    const status = this.#getTodayStatus(openingHours);
    const detailsId = `StoreLocatorDetails-${this.#slug(key || name || fullAddress)}`;

    return `<article class="store-card">
  <div class="store-card__header">
    <div>
      <h2 class="store-card__name">${this.#esc(name || cityLine || 'Store')}</h2>
      ${cityLine ? `<p class="store-card__meta">${this.#esc(cityLine)}</p>` : ''}
    </div>
  </div>
  ${fullAddress ? `<p class="store-card__address">${this.#esc(fullAddress)}</p>` : ''}
  <p class="store-card__status${status.isOpen ? ' store-card__status--open' : ' store-card__status--closed'}">
    ${this.#esc(status.text)}
  </p>
  <div class="store-card__actions">
    <a
      href="${this.#esc(mapsUrl)}"
      target="_blank"
      rel="noopener noreferrer"
      class="store-card__btn store-card__btn--primary"
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="currentColor"/>
      </svg>
      Get directions
    </a>
    ${
      phone
        ? `<a href="tel:${this.#esc(phone)}" class="store-card__btn store-card__btn--primary">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" fill="currentColor"/>
      </svg>
      Call ${this.#esc(phone)}
    </a>`
        : ''
    }
    <button type="button" class="store-card__btn store-card__btn--secondary store-card__details-toggle" aria-expanded="false" aria-controls="${detailsId}">
      <span class="store-card__label-more">More details</span>
      <span class="store-card__label-less">Less details</span>
      <svg class="store-card__chevron" width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>
  <div id="${detailsId}" class="store-card__hours" hidden>
    ${
      address.email
        ? `<p class="store-card__detail-line">Email: <a href="mailto:${this.#esc(address.email)}">${this.#esc(address.email)}</a></p>`
        : ''
    }
    ${address.fax ? `<p class="store-card__detail-line">Fax: ${this.#esc(address.fax)}</p>` : ''}
    ${address.email || address.fax ? '<hr class="store-card__divider">' : ''}
    ${this.#renderHoursRows(openingHours)}
  </div>
</article>`;
  }

  #renderHoursRows(openingHours = {}) {
    const todayName = TODAY_NAMES[new Date().getDay()];

    return `<table class="store-card__hours-table" aria-label="Opening hours">
  <tbody>
    ${DAY_NAMES.map((day) => {
      const hours = openingHours?.[day];
      const hoursText =
        hours?.from && hours?.to
          ? `${this.#formatTime(hours.from)} - ${this.#formatTime(hours.to)}`
          : 'Closed';
      const label = day.charAt(0).toUpperCase() + day.slice(1);

      return `<tr class="${day === todayName ? 'store-card__hours-today' : ''}">
      <th scope="row">${label}</th>
      <td>${hoursText}</td>
    </tr>`;
    }).join('')}
  </tbody>
</table>`;
  }

  #getTodayStatus(openingHours = {}) {
    const now = new Date();
    const todayName = TODAY_NAMES[now.getDay()];
    const todayHours = openingHours?.[todayName];

    if (!todayHours?.from || !todayHours?.to) {
      return { text: 'Closed today', isOpen: false };
    }

    const [fromH, fromM] = todayHours.from.split(':').map(Number);
    const [toH, toM] = todayHours.to.split(':').map(Number);
    const nowMinutes = now.getHours() * 60 + now.getMinutes();
    const openMinutes = fromH * 60 + fromM;
    const closeMinutes = toH * 60 + toM;

    if (nowMinutes < openMinutes) {
      return { text: `Closed, opens at ${this.#formatTime(todayHours.from)}`, isOpen: false };
    }

    if (nowMinutes >= closeMinutes) {
      return { text: 'Closed today', isOpen: false };
    }

    return { text: `Open until ${this.#formatTime(todayHours.to)} today`, isOpen: true };
  }

  #getGeolocationErrorMessage(error) {
    switch (error.code) {
      case error.PERMISSION_DENIED:
        return 'Location access was blocked. Allow access to use your current location.';
      case error.POSITION_UNAVAILABLE:
        return 'Your current location could not be determined.';
      case error.TIMEOUT:
        return 'Location lookup timed out. Please try again.';
      default:
        return 'We could not determine your current location.';
    }
  }

  #formatTime(timeStr) {
    const [hours, minutes] = timeStr.split(':').map(Number);
    const period = hours < 12 ? 'am' : 'pm';
    const hour12 = hours === 0 ? 12 : hours > 12 ? hours - 12 : hours;
    const minuteText = minutes === 0 ? '' : `:${String(minutes).padStart(2, '0')}`;

    return `${hour12}${minuteText}${period}`;
  }

  #setStatus(message, tone = 'info') {
    const statusBar = this.refs.statusBar;
    const statusText = this.refs.statusText;

    if (!(statusBar instanceof HTMLElement) || !(statusText instanceof HTMLElement)) return;

    if (!message) {
      statusBar.hidden = true;
      statusBar.removeAttribute('data-tone');
      statusText.textContent = '';
      return;
    }

    statusBar.hidden = false;
    statusBar.dataset.tone = tone;
    statusText.textContent = message;
  }

  #setLoading(isLoading) {
    const resultsRegion = this.refs.resultsRegion;
    const searchButton = this.refs.searchBtn;
    const useLocationButton = this.refs.useLocation;

    if (resultsRegion instanceof HTMLElement) {
      resultsRegion.setAttribute('aria-busy', String(isLoading));
    }

    if (searchButton instanceof HTMLButtonElement) {
      searchButton.disabled = isLoading;
      searchButton.setAttribute('aria-disabled', String(isLoading));
    }

    if (useLocationButton instanceof HTMLButtonElement) {
      useLocationButton.disabled = isLoading;
      useLocationButton.setAttribute('aria-disabled', String(isLoading));
    }
  }

  #haversine(lat1, lng1, lat2, lng2) {
    const earthRadiusKm = 6371;
    const toRadians = (value) => (value * Math.PI) / 180;
    const deltaLat = toRadians(lat2 - lat1);
    const deltaLng = toRadians(lng2 - lng1);

    const a =
      Math.sin(deltaLat / 2) ** 2 +
      Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) * Math.sin(deltaLng / 2) ** 2;

    return earthRadiusKm * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  #slug(value) {
    return String(value)
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'store';
  }

  #esc(str) {
    return String(str ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
}

if (!customElements.get('store-locator')) {
  customElements.define('store-locator', StoreLocator);
}
